import React from "react";
import styles from "./contact.module.css";

const MapSection = () => {
  return (
    <section className={styles.teamSection}>
      <h2 className={styles.mainTitle}>JOIN OUR TEAM</h2>
      <div className={styles.joinBox}>
        {/* Column 1: Design Team */}
        <div className={styles.column}>
          <h3>DESIGN TEAM</h3>
          <ul>
            <li>Architect</li>
            <li>Interior Designer</li>
            <li>Civil Engineer</li>
            <li>Site Supervisor</li>
            <li>Draftsperson</li>
            <li>Graphics Designer</li>
          </ul>
        </div>

        {/* Column 2: Studio Team */}
        <div className={styles.column}>
          <h3>STUDIO TEAM</h3>
          <ul>
            <li>Accounts</li>
            <li>Marketing / Media</li>
            <li>Human Resource</li>
            <li>Public Relations</li>
            <li>Photographer</li>
          </ul>
        </div>

        {/* Column 3: Apply Now */}
        <div className={styles.column}>
          <h3>APPLY NOW</h3>
          <div className={styles.applyContent}>
            <p>
              We invite all qualified candidates to submit their CV/Resumes and
              Portfolios to join our team.
            </p>
            <div className={styles.links}>
              <a href="mailto:info@9griddesign.com" style={{ textTransform: 'lowercase' }}>info@9griddesign.com</a>
              <a href="mailto:info.9griddesign@gmail.com" style={{ textTransform: 'lowercase' }}>info.9griddesign@gmail.com</a>
            </div>
          </div>
        </div>

      </div>
      <div className={styles.mapWrapper}>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7367.225207127528!2d88.39829100000001!3d22.593588000000004!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a0277dfbbcfd875%3A0x5eb2f0562e9ba9e4!2s9GRID%20DESIGN!5e0!3m2!1sen!2sin!4v1767270858679!5m2!1sen!2sin"
          width="100%"
          height="550"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="9Grid Location"
          className={styles.darkIframe}
        ></iframe>


      </div>
      <div className={styles.joinBox}>
      </div>
    </section>
  );
};

export default MapSection;
